<template>
	<v-app style="background-color: #EEF0F8;">
		<router-view></router-view>
	</v-app>
</template>

<script>
export default {
	name: "app"
};
</script>

<style src="./css/global.scss" lang="scss"></style>
